import React from "react";
import { Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { CollapsiblePanel, ShowValue } from "src/apps/commons/dataDisplays";
import { IUserProductContainer } from "../types";

const useStyles = makeStyles(theme =>
  createStyles({
    wrapper: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      width: "100%"
    },
    avatar: {
      padding: theme.spacing(0, 2),
      alignContent: "center",
      "& > img": {
        width: 72,
        height: 72,
        borderRadius: 36
      }
    }
  })
);

interface Props {
  data: IUserProductContainer;
}

const UserInfo: React.FC<Props> = props => {
  const classes = useStyles();
  const { data } = props;
  const { user } = data.product;

  return (
    <CollapsiblePanel title="ข้อมูลลูกค้า" icon="info">
      <div className={classes.wrapper}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <ShowValue label="ชื่อ" value={user.displayName} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ShowValue label="Email" value={user.email} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ShowValue label="เบอร์โทร" value={user.phoneNumber} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ShowValue label="Firebase UID" value={user.firebaseUid} />
          </Grid>
        </Grid>
        {user.photoUrl && (
          <div className={classes.avatar}>
            <img alt="Profile" src={user.photoUrl} />
          </div>
        )}
      </div>
    </CollapsiblePanel>
  );
};

export default UserInfo;
